import { NgIf } from '@angular/common';
import { AfterViewInit, ChangeDetectionStrategy, Component, TemplateRef, ViewChild } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { CartLine, OrderTypes } from '@next/core-lib/cart';
import { DialogService } from '@next/core-lib/dialog';
import { LocaleService, AgrI18nSharedModule } from '@next/core-lib/i18n';
import { Store } from '@ngrx/store';

import { openDeliveryDateDialog } from 'src/app/cart/store/actions';
import { AppState } from 'src/app/models/app.models';
import { FormatFlexibilityDatePipe } from 'src/app/product/pipes/format-flexibility-date.pipe';

import { DeliveryDateHelpDialogComponent } from '../delivery-date-help-dialog/delivery-date-help-dialog.component';

@Component({
  templateUrl: './column-delivery-date.component.html',
  styleUrls: ['./column-delivery-date.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgIf, MatButton, MatIcon, AgrI18nSharedModule, FormatFlexibilityDatePipe],
})
export class ColumnDeliveryDateComponent implements AfterViewInit {
  @ViewChild('template') template: TemplateRef<unknown>;
  public cartId: number;
  public orderType?: OrderTypes;
  public editable: boolean;
  public initCallback: () => void;
  public returnableOrderType = OrderTypes.returnableOrder;

  constructor(
    private readonly store: Store<AppState>,
    private readonly dialogService: DialogService,
    private readonly locale: LocaleService,
  ) {}
  get isRushEmergencyCart() {
    return this.orderType === OrderTypes.rushOrder || this.orderType === OrderTypes.emergencyOrder;
  }

  ngAfterViewInit() {
    this.initCallback();
  }

  public openDeliveryDate(cartLine: CartLine): void {
    if (this.isRushEmergencyCart) {
      this.openDeliveryDateHelpModal();
      return;
    }
    this.store.dispatch(
      openDeliveryDateDialog({
        cartIdentifier: this.cartId,
        cartLine,
        orderType: this.orderType,
      }),
    );
  }

  private openDeliveryDateHelpModal() {
    this.dialogService.responsiveDialog(DeliveryDateHelpDialogComponent, {
      title: this.locale.translate('cart.cart-delivery-date-help-modal.title'),
      cancelButton: false,
      disableClose: true,
      confirmButtonText: this.locale.translate('cart.cart-help-modal.close'),
      confirmButton: true,
    });
  }
}
